import React from 'react';
import createUseContext from 'constate';

const SHOPPING_CART_LOCAL_STORAGE_KEY = 'SHOPPING_CART';

const ACTION_TYPE = {
  SET: 'SET',
};

let initialShoppintCart = {};
try {
  initialShoppintCart = JSON.parse(localStorage.getItem(SHOPPING_CART_LOCAL_STORAGE_KEY) || '{}');
} catch (error) {
  localStorage.removeItem(SHOPPING_CART_LOCAL_STORAGE_KEY);
}
const initialState = {
  shoppingCart: initialShoppintCart,
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPE.SET:
      return {
        shoppingCart: action.payload,
      };
    default:
      throw new Error();
  }
};

const useShoppingCart = () => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const {
    shoppingCart,
  } = state;
  const setShoppingCart = (data) => {
    dispatch({
      type: ACTION_TYPE.SET,
      payload: data,
    });
    localStorage.setItem(SHOPPING_CART_LOCAL_STORAGE_KEY, JSON.stringify(data));
  };
  const addPreOrderToShoppingCart = ({
    preOrderId, amount, fridgeId,
    batch, date, timeSlot,
  }) => {
    setShoppingCart({
      ...shoppingCart,
      [preOrderId]: {
        amount: 1,
        ...(shoppingCart[preOrderId] || {}),
        ...(amount !== undefined ? { amount } : {}),
        ...(fridgeId !== undefined ? { fridgeId } : {}),
        ...(batch !== undefined ? { batch } : {}),
        ...(date !== undefined ? { date } : {}),
        ...(timeSlot !== undefined ? { timeSlot } : {}),
      },
    });
  };

  const removePreOrderFromShoppingCart = (preOrderIds = []) => {
    const newShoppingCart = preOrderIds.reduce((result, preOrderId) => {
      const {
        [preOrderId]: preOrer,
        ...restOfShoppingCart
      } = result;
      return restOfShoppingCart;
    }, shoppingCart);
    setShoppingCart(newShoppingCart);
  };

  return {
    shoppingCart,
    addPreOrderToShoppingCart,
    removePreOrderFromShoppingCart,
  };
};

const [ShoppingCartProvider, useShoppingCartContext] = createUseContext(useShoppingCart);

export {
  ShoppingCartProvider,
  useShoppingCartContext,
};
